import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {


  //console.log("Grand Total", totals);
const parseAmount = (value) => {
  if (value == null) return 0;

  let str = String(value).replace(/,/g, "").trim();

  // Handle trailing minus
  if (str.endsWith("-")) {
    str = "-" + str.slice(0, -1);
  }

  return Number(str) || 0;
};


const totalLabour = (parseAmount(totals.DirectLabour) || 0) + (parseAmount(totals.OnCostLabour) || 0);
const totalStore = (parseAmount(totals.DirectStore) || 0) + (parseAmount(totals.OnCostStore) || 0);

  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >
     

      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >
       

    


        <Grid size={{ xs: 12, md: 4 }} >

          <TableContainer
            component={Paper}
            variant="outlined"
           
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    //colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Description
                  </TableCell>

                  <TableCell
                   // colSpan={2}
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 16,
                    }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>


 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                     Total Labour
                    </Typography>
                    
                  </TableCell>


                  <TableCell align="right">
                    <CurrencyCell value={totalLabour} />
                  </TableCell>

                </TableRow> 


                 <TableRow>
                  <TableCell>
                    <Typography fontWeight="bold">
                      Total Store
                    </Typography>
                    
                  </TableCell>

                  <TableCell align="right">
                    <CurrencyCell value={totalStore} />
                  </TableCell>
                </TableRow>



                <TableRow>
                  <TableCell
                    colSpan={2}
                    sx={{ bgcolor: "grey.100", py: 0.5 }}
                  />
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>

        </Grid>



      </Grid>
    </Paper>
  );
}